import { useEffect } from 'react';
import styles from './index.module.scss';
import { analytics } from '../../app-loader';
import useAppStore from '../../app-store';
import useStore from './store';
import { Button } from '@autopass-web/mochi-component';
import dynamic from 'next/dynamic';
const SuccessPayment = dynamic(
  () => import('@autopass-web/mochi-payment').then((mod) => mod.SuccessPayment),
  {
    ssr: false,
  },
);

const SuccessCard = () => {
  const store = useStore();
  const appStore = useAppStore();

  useEffect(() => {
    analytics.barcode_payment_success_pageview(
      store.barcodePaymentResult.data.chainStoreName,
      store.barcodePaymentResult.data.amount,
    );
  }, []);

  return (
    <div className={styles.success}>
      <SuccessPayment
        amount={store.barcodePaymentResult.data.amount}
        name={store.barcodePaymentResult.data.store_name}
        discount={store.barcodePaymentResult.data.discounts.reduce(
          (acc, cur) => acc + parseInt(cur.price),
          0,
        )}
        message={
          appStore.app === 'enterprise-driver'
            ? ''
            : '詳細明細請至「消費紀錄」查看'
        }
        button={
          <Button
            type="solid-round"
            onClick={() => {
              analytics.barcode_payment_success_onClick();
              analytics.barcode_payment_leave({ action: '交易完成' });
              appStore.globalAction.backToMain();
            }}
            style={{
              margin: '24px auto 0',
              width: 100,
              height: 50,
              borderRadius: 25,
              fontSize: 18,
            }}
          >
            完成
          </Button>
        }
        showDownloadApp={false}
      />
    </div>
  );
};

export default SuccessCard;
